export const colors = {

    bg1: "linear-gradient(0deg, #000000ff, #0C122Fff, #0C132Fff, #0C0E2Fff, #0C102Fff)",
    bg2: "#F6F9FF",
    // gr_bg: "linear-gradient(90deg,#B8860B 0%,#D4AF37, #B8860F 100%)",
    // gr_bg2: "linear-gradient(90deg,#B8860B 0%,#ffc107, #B8860F 100%)",
    gr_bg: "linear-gradient(90deg, #0C132F -70%, #B8860F, #ffc107 100%)",
    gr_bg2: "linear-gradient(90deg,#B8860B 0%,#ffc107, #B8860F 100%)",
    copy_bg: "#122340",
    blue: "#2c97ea",
    green: "#ffc107",
    green2: "#D4AF37",
    red: "#B8860F",
    purple: "#0C122Fff",
    yellow: "#fbab19",
    black1: "#182B49",
    black2: "#444444",
    text1: "#555555",
    text2: "#666666",
    text3: "#969696",
    text4: "#aaaaaa",
    text5: "#cccccc",
    border1: "#eeeeee",
    border2: "#3e3e3e",
    border3: "#dddddd",
    footer1: "#1a1b25",
    footer2: "#16171f",
    ftext: "#8D8E92",

}

export const fonts = {

    roboto: "'Roboto', sans-serif",
    poppins: "'Poppins', sans-serif",

}